export default "__VITE_ASSET__768bee3b__"